import ClientDosemeterMeasurementList from 'components/client-dosemeter-measurement/measurement-list'
import ClientMeasurementReportList from 'components/client-measurement-report/report-list'
import {
  PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST, PATH_CLIENT_MEASUREMENT_REPORT_LIST
} from 'routing/path'

const clientRoutes = [
  { path: PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST, component: ClientDosemeterMeasurementList },
  { path: PATH_CLIENT_MEASUREMENT_REPORT_LIST, component: ClientMeasurementReportList }
]
export { clientRoutes }
